var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_203",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 22C25.1 22 26.0417 21.6083 26.825 20.825C27.6083 20.0417 28 19.1 28 18C28 16.9 27.6083 15.9583 26.825 15.175C26.0417 14.3917 25.1 14 24 14C22.9 14 21.9583 14.3917 21.175 15.175C20.3917 15.9583 20 16.9 20 18C20 19.1 20.3917 20.0417 21.175 20.825C21.9583 21.6083 22.9 22 24 22ZM14 42V38H22V31.8C20.3667 31.4333 18.9083 30.7417 17.625 29.725C16.3417 28.7083 15.4 27.4333 14.8 25.9C12.3 25.6 10.2083 24.5083 8.525 22.625C6.84167 20.7417 6 18.5333 6 16V14C6 12.9 6.39167 11.9583 7.175 11.175C7.95833 10.3917 8.9 10 10 10H14V6H34V10H38C39.1 10 40.0417 10.3917 40.825 11.175C41.6083 11.9583 42 12.9 42 14V16C42 18.5333 41.1583 20.7417 39.475 22.625C37.7917 24.5083 35.7 25.6 33.2 25.9C32.6 27.4333 31.6583 28.7083 30.375 29.725C29.0917 30.7417 27.6333 31.4333 26 31.8V38H34V42H14ZM14 21.6V14H10V16C10 17.2667 10.3667 18.4083 11.1 19.425C11.8333 20.4417 12.8 21.1667 14 21.6ZM24 28C25.6667 28 27.0833 27.4167 28.25 26.25C29.4167 25.0833 30 23.6667 30 22V10H18V22C18 23.6667 18.5833 25.0833 19.75 26.25C20.9167 27.4167 22.3333 28 24 28ZM34 21.6C35.2 21.1667 36.1667 20.4417 36.9 19.425C37.6333 18.4083 38 17.2667 38 16V14H34V21.6Z",
    fill: "#00E378"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamification);
export default __webpack_public_path__ + "static/media/gamification.75f2b3aad21b7dbf53289f26df3cb200.svg";
export { ForwardRef as ReactComponent };